<template>
    <AppLayout>
        <div class="row">
            <div class="col-md-10 mx-auto">
                <div class="card">
                    <div class="card-header bg-info text-white">
                        <h2 class="card-title mb-0">About Our Application</h2>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-8">
                                <h4>Technology Stack</h4>
                                <ul class="list-group list-group-flush mb-4">
                                    <li class="list-group-item">
                                        <strong>Backend:</strong> Laravel {{ laravelVersion }}
                                    </li>
                                    <li class="list-group-item">
                                        <strong>Frontend:</strong> Vue.js 3 with Composition API
                                    </li>
                                    <li class="list-group-item">
                                        <strong>SPA Framework:</strong> Inertia.js
                                    </li>
                                    <li class="list-group-item">
                                        <strong>CSS Framework:</strong> Bootstrap 5
                                    </li>
                                    <li class="list-group-item">
                                        <strong>JavaScript Library:</strong> jQuery
                                    </li>
                                    <li class="list-group-item">
                                        <strong>Build Tool:</strong> Vite
                                    </li>
                                </ul>

                                <h4>Features</h4>
                                <div class="row">
                                    <div class="col-md-6">
                                        <ul class="list-unstyled">
                                            <li><i class="bi bi-check-circle-fill text-success me-2"></i>Server-side rendering</li>
                                            <li><i class="bi bi-check-circle-fill text-success me-2"></i>Hot module replacement</li>
                                            <li><i class="bi bi-check-circle-fill text-success me-2"></i>Component-based architecture</li>
                                            <li><i class="bi bi-check-circle-fill text-success me-2"></i>Reactive data binding</li>
                                        </ul>
                                    </div>
                                    <div class="col-md-6">
                                        <ul class="list-unstyled">
                                            <li><i class="bi bi-check-circle-fill text-success me-2"></i>Bootstrap components</li>
                                            <li><i class="bi bi-check-circle-fill text-success me-2"></i>jQuery integration</li>
                                            <li><i class="bi bi-check-circle-fill text-success me-2"></i>Responsive design</li>
                                            <li><i class="bi bi-check-circle-fill text-success me-2"></i>Modern ES6+ syntax</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card bg-light">
                                    <div class="card-header">
                                        <h5 class="mb-0">Quick Stats</h5>
                                    </div>
                                    <div class="card-body">
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <span>Build Time</span>
                                            <span class="badge bg-primary">{{ buildTime }}</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <span>Environment</span>
                                            <span class="badge bg-success">Development</span>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <span>Status</span>
                                            <span class="badge bg-success">Active</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt-3">
                                    <a href="/" class="btn btn-outline-primary w-100">Back to Home</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import { ref, onMounted } from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'

export default {
    name: 'About',
    components: {
        AppLayout
    },
    props: {
        laravelVersion: {
            type: String,
            default: '11.x'
        }
    },
    setup() {
        const buildTime = ref('')

        onMounted(() => {
            buildTime.value = new Date().toLocaleTimeString()
        })

        return {
            buildTime
        }
    }
}
</script>

<style scoped>
.list-group-item {
    border: none;
    padding-left: 0;
}

.bi::before {
    vertical-align: -.125em;
}
</style>
